module.exports = __webpack_public_path__ + "static/media/familyReadingColor.bfe5c3d8.jpeg";